import { useQuery } from '@tanstack/react-query';
import { AttentionItemMapper, DashboardSummaryMapper, TransactionMapper } from '@/api/mapper/dashboard';
import { getDashboardAttention, getDashboardSummary, getDashboardTransactions } from '@/api/service/dashboard';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  summary: ['dashboard', 'summary'] as const,
  transactions: ['dashboard', 'transactions'] as const,
  attention: ['dashboard', 'attention'] as const,
};

export function useDashboardSummaryQuery(enabled = true) {
  return useQuery({
    queryKey: dashboardKeys.summary,
    queryFn: async () => DashboardSummaryMapper(await getDashboardSummary()),
    enabled,
  });
}

/** Full Recent Transactions list, loaded when its View All modal opens. */
export function useDashboardTransactionsQuery(enabled = true) {
  return useQuery({
    queryKey: dashboardKeys.transactions,
    queryFn: async () => ((await getDashboardTransactions()).data ?? []).map(TransactionMapper),
    enabled,
  });
}

/** Full Attention Required list, loaded when its View All modal opens. */
export function useDashboardAttentionQuery(enabled = true) {
  return useQuery({
    queryKey: dashboardKeys.attention,
    queryFn: async () => ((await getDashboardAttention()).data ?? []).map(AttentionItemMapper),
    enabled,
  });
}
